export enum EmployeeDetailsTab {
  GENERAL = 'general',
  CONFIGURATION = 'configuration',
  ANNUAL_CONSUMPTION = 'annual_consumption'
}
